import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";

import { MAX_LENGTH } from "./Advice/Advice";
import DebouncedTextField from "../../components/DebouncedTextField";
import useAssessmentLabel from "../../hooks/useAssessmentLabel";

// @ts-expect-error - css
import styles from "./Assessment.module.css";

const PastHistoryOfAllergy = ({
  assessmentPastHistoryOfAllergy,
  onChange
}: {
  assessmentPastHistoryOfAllergy: string;
  onChange: (value: string) => void;
}): React.ReactNode => {
  const assessmentLabels = useAssessmentLabel();
  const [localValue, setLocalValue] = React.useState(assessmentPastHistoryOfAllergy || "");

  useEffect(() => {
    setLocalValue(assessmentPastHistoryOfAllergy || "");
  }, [assessmentPastHistoryOfAllergy]);

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.pastHistoryOfAllergy}
        </Typography>
      </Box>
      <Box className={styles.assessmentField}>
        <DebouncedTextField
          data-testmation="PastHistoryOfAllergy"
          margin="dense"
          variant="outlined"
          fullWidth
          multiline
          maxRows={3}
          value={localValue}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: { maxLength: MAX_LENGTH },
            formHelperText: { style: { position: "absolute", right: 0, bottom: 0, margin: 5 } }
          }}
          placeholder="Type past history of allergy"
          onChange={(e) => {
            setLocalValue(e.target.value);
            onChange(e.target.value);
          }}
          debounceAt={400}
          onFocus={(e) => e.target.select()}
          helperText={`${localValue.length}/${MAX_LENGTH}`}
        />
      </Box>
    </Box>
  );
};

export default PastHistoryOfAllergy;
